export default __webpack_public_path__ + "static/media/profile.b76c5ad8.jpg";